/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntrustSignatureEvidenceFolderDto } from '../../models/entrust-signature-evidence-folder-dto';

export interface GetEvidenceFolders$Params {
  processId: string;
}

export function getEvidenceFolders(http: HttpClient, rootUrl: string, params: GetEvidenceFolders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EntrustSignatureEvidenceFolderDto>>> {
  const rb = new RequestBuilder(rootUrl, getEvidenceFolders.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EntrustSignatureEvidenceFolderDto>>;
    })
  );
}

getEvidenceFolders.PATH = '/kyc/processes/{processId}/signature/evidence-folders';
